<div class="person-tile">
  <div class="person-tile-wrapper">
    <div class="person-checkbox">
      @if (showCheckbox()) {
        @if (isDisabled()) {
          <ui-filter-chip
            [title]="'PERSONS.IN_GROUP' | translate"
            [allowDelete]="false"
          ></ui-filter-chip>
        } @else {
          <mat-checkbox
            [checked]="value()"
            (change)="onCheckboxChange($event.checked)"
          ></mat-checkbox>
        }
      }
    </div>
    @if (showConfirmationStatus()) {
      <div
        class="confirmation-status"
        [class.confirmed]="isConfirmed()"
        [class.confirming]="isConfirming()"
      >
        @if (isConfirming()) {
          <ui-preloader
            [diameter]="20"
            [color]="preloaderColor.blue"
          ></ui-preloader>
        } @else {
          <span
            class="ui-icon-trained"
            [class.green]="isConfirmed()"
            [class.orange]="!isConfirmed()"
            [matTooltip]="
              (isConfirmed()
                ? 'PERSONS.TOOLTIPS.TRAINED'
                : 'PERSONS.TOOLTIPS.NEEDS_TRAINING'
              ) | translate
            "
            matTooltipClass="sidebar-tooltip"
            (click)="$event.stopPropagation(); !isConfirmed() && confirm.emit()"
          ></span>
        }
      </div>
    }
    <div class="person-tile-actions">
      <ng-content></ng-content>
    </div>
    <img
      class="person-image"
      [appAuthSrc]="imageUrl()"
      [appAuthSrcFallback]="imageUrlFallback()"
      [defaultImage]="defaultPersonImage"
      [alt]="label()"
      (authLoaded)="imageLoaded.emit()"
      (authError)="imageError.emit()"
    />
    <span class="person-label" uiTruncateText>{{ label() }}</span>
  </div>
</div>
